import { memo } from 'react';

import InfoFilledIconSVG from '@/assets/info-filled-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IInfoFilledIcon = (props: Omit<IconProps, 'SVGComponent'>) => (
  <Icon SVGComponent={InfoFilledIconSVG} {...props} />
);

export const InfoFilledIcon = memo(IInfoFilledIcon) as typeof IInfoFilledIcon;
